import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
    singleParameter,
} from '/b2b/common/helpers/ReduxHelpers.js';

import { DOMAIN } from './AssessmentsReporting.constants';

export const events = {
    setFilters: singleParameter,
};

export const asyncEvents = makeAsyncEvents(['update'], true);

export const types = makeActionTypes([...Object.keys(events), ...Object.keys(asyncEvents)], DOMAIN);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
    },
    types
);
